export const getQueryParams = (url: string) => {
  const urlObj = new URL(url);
  return [...urlObj.searchParams].reduce((acc, [key, value]) => {
    acc[key] = value;
    return acc;
  }, {});
};
